<template>
    <div class="education">
        <C1FormGroup>
            <C1Select
                id="type"
                v-model="form.education_level"
                :label="$t('label.qualification_type')"
                label-for="type"
                :options="educationLevel"
                name="type"
                :placeholder="$t('label.enter_value', {value: $t('label.qualification_type')})"
                label-key="value"
                value-key="id"
                hide-input-icon
            />
        </C1FormGroup>

        <C1FormGroup>
            <div class="afu-flex afu-items-center afu-justify-between">
                <C1Label label-for="startDate">
                    {{ $t('label.start_end_dates') }}
                </C1Label>

                <div class="afu-flex afu-items-center afu-text-sm afu-mb-2">
                    <span class="afu-mr-2">{{ $t('label.in_progress') }}</span>

                    <C1AppleSwitch
                        v-model="inProgress"
                        size="xs"
                    />
                </div>
            </div>

            <div class="afu-grid md:afu-grid-cols-2 afu-gap-2">
                <C1FormInput
                    id="startDate"
                    v-model="form.start_date"
                    type="month"
                    :placeholder="$t('label.select_value', {value: $t('label.start_date')})"
                    :max="form.end_date || today"
                />

                <C1FormInput
                    v-if="form.is_complete"
                    id="endDate"
                    key="end-date-picker"
                    v-model="form.end_date"
                    type="month"
                    :placeholder="$t('label.select_value', {value: $t('label.end_date')})"
                    :min="form.start_date"
                    :max="today"
                />

                <C1FormInput
                    v-else
                    key="end-date-progress"
                    type="text"
                    disabled
                    :placeholder="$t('label.in_progress')"
                />
            </div>
        </C1FormGroup>

        <C1FormGroup>
            <C1FormInput
                id="courseName"
                :label="$t('label.course_name')"
                label-for="courseName"
                v-model="form.qualification_name"
                name="courseName"
                :placeholder="$t('label.enter_value', {value: $t('label.course_name')})"
            />
        </C1FormGroup>

        <C1FormGroup>
            <C1FormInput
                id="institution"
                :label="$t('label.institution_name')"
                label-for="institution"
                v-model="form.institution"
                name="institution"
                :placeholder="$t('label.enter_value', {value: $t('label.institution_name')})"
                trim
            />
        </C1FormGroup>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import has from 'lodash/has';
    import moment from 'moment/src/moment';
    import C1FormInput from '@/components/C1Components/C1FormInput';
    import C1FormGroup from '@/components/C1Components/C1FormGroup';
    import C1Label from '@/components/C1Components/C1Label';
    import C1Select from '@/components/C1Components/C1Select';
    import C1AppleSwitch from '@/components/C1Components/C1AppleSwitch';

    export default {
        name: 'EducationForm',

        components: {
            C1Select,
            C1Label,
            C1FormGroup,
            C1FormInput,
            C1AppleSwitch,
        },

        props: {
            education: {
                type: Object,
                default: () => {
                    return {};
                },
            },
        },

        data() {
            return {
                form: {
                    id: null,
                    qualification_name: '',
                    education_level: {},
                    institution: '',
                    is_complete: false,
                    start_date: '',
                    end_date: '',
                },
                educationLevel: [],
                today: '',
            };
        },

        computed: {
            inProgress: {
                get() {
                    return !this.form.is_complete;
                },

                set(value) {
                    this.form.is_complete = !value;
                },
            },

            getQualificationTypeId() {
                return has(this.form, 'education_level.id')
                    ? this.form.education_level.id
                    : '';
            },
        },

        watch: {
            form: {
                handler() {
                    this.onDataChange();
                },
                deep: true,
            },
        },

        created() {
            this.getInitialData();
            this.fillForm();
        },

        methods: {
            ...mapActions('attribute', {
                $_getEducationLevel: 'getEducationLevel',
            }),

            getInitialData() {
                this.$_getEducationLevel().then(response => {
                    this.educationLevel = response.data;
                });
                this.today = moment().format('yyyy-MM');
            },

            fillForm() {
                if (this.education.id) {
                    this.form.id = this.education.id;
                    this.form.qualification_name = this.education.qualification_name;
                    this.form.education_level = has(
                        this.education,
                        'educationLevel.id',
                    )
                        ? this.education.educationLevel
                        : {};
                    this.form.institution = this.education.institution;
                    this.form.is_complete = this.education.is_complete;
                    this.form.start_date = this.education.start_date
                        ? moment(this.education.start_date).format('yyyy-MM')
                        : '';
                    this.form.end_date = this.education.end_date
                        ? moment(this.education.end_date).format('yyyy-MM')
                        : '';
                }
            },

            dateFormatter(date) {
                return moment
                    .utc(date)
                    .local()
                    .format('MMMM YYYY');
            },

            onDataChange() {
                this.$emit('change', this.form);
            },
        },
    };
</script>
